import { combineReducers } from '@reduxjs/toolkit'

import devices from './devices'

export default combineReducers({
  devices,
})
